module.exports = "/assets/data/44c719cc2068ac74b922fd83cfd65d9e-NE27.data.json";